import { ChangeSummaryField } from "@/components/ui/VersionReviewDialog/ChangeSummaryField";

interface CommitMessageProps {
  message: string;
  setMessage: (message: string) => void;
  label?: string;
}

const CommitMessage = ({ message, setMessage, label }: CommitMessageProps) => (
  <ChangeSummaryField
    message={message}
    setMessage={setMessage}
    label={label || "Prompt version change message (Optional)"}
    placeholder="Enter a commit message"
  />
);

export default CommitMessage;
